module.exports = __webpack_public_path__ + "img/6.a7e2f17e.webp";